import React, { useState, useContext, } from 'react';
import axios from 'axios';
import {
  Box,
  Table,
  TableRow,
  TableBody,
  TableHead,
  Collapse,
  IconButton,
  CircularProgress,
  Grid,
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import LinkIcon from '@material-ui/icons/Link';
import Videocam from "@material-ui/icons/Videocam";
import PropTypes from 'prop-types';
import { storeContext } from '../provider/Provider';
import {
  StyledTableCell,
  StyledTableHeadCell,
} from '../../customUI/table/TableStyles';
import useStyles from './SearchIntelligence.style';
import theme from '../../theme';

const { REACT_APP_SEARCH_INTELLIGENCE_API_KEY } = process.env;

const SearchIntelligenceRow = ({row}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const { state } = useContext(storeContext);
  const [isFetching, setIsFetching] = useState(false);
  const [placements, setPlacements] = useState([]);
  
  const handleRowClick = () => {
    if(!open){
      setIsFetching(true);
      axios
      .get(
          `https://admin.search-intelligence.co.uk/wp-json/si-rest-api/v1/client/placements?domain=${state.websiteSwitch.currentWebsite}&campaign_name=${row.campaign_name}&all_placements=1`,
          {
            headers:{'x-api-key': REACT_APP_SEARCH_INTELLIGENCE_API_KEY,},
          }
      )
      .then((res) => {
          setIsFetching(false);
          setPlacements(res.data)
      })
      .catch(() => {
        setIsFetching(false);
      });
    }
    setOpen(!open);
  }

  const capitalization = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

  return (
    <>
        <TableRow key={row.campaign_name} style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.1)'}}>
            <StyledTableCell component="th" scope="row" style={{ background: 'rgba(0, 180, 224, 0.1)'}}>
              <Box display="flex" flexDirection="row" style={{ textTransform: "capitalize"}}>
                <IconButton
                    aria-label="expand row"
                    className={classes.arrowButton}
                    onClick={handleRowClick}
                >
                    {open ? (
                    <KeyboardArrowUpIcon style={{ fontSize: 'medium' }} />
                    ) : (
                    <KeyboardArrowDownIcon style={{ fontSize: 'medium' }} />
                    )}
                </IconButton>
                {row.year}
              </Box>
            </StyledTableCell>
            <StyledTableCell component="th" scope="row" style={{ background: 'rgba(0, 180, 224, 0.1)'}}>
              {row.month}
            </StyledTableCell>
            <StyledTableCell component="th" scope="row" style={{ background: 'rgba(214, 255, 212, 0.3)'}}>
              {capitalization(row.campaign_name)}
            </StyledTableCell>
            <StyledTableCell component="th" scope="row">
              {row.first_link_date && !Number.isNaN(new Date(row.first_link_date).getTime()) ? `${new Date(row.first_link_date).toLocaleString('en-US', {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
              })}` : "-"}
            </StyledTableCell>
            <StyledTableCell component="th" scope="row" style={{ background: 'rgba(0, 180, 224, 0.1)'}}>
              {row.ht_count_links}
            </StyledTableCell>
            <StyledTableCell component="th" scope="row" style={{ background: 'rgba(0, 180, 224, 0.1)'}}>
              {row.count_links}
            </StyledTableCell>
            <StyledTableCell>
              {row.status}
            </StyledTableCell>
            <StyledTableCell>
              {row.video ? (
                <Box display='flex' flex={1} justifyContent='center' style={{width: "100%"}}>
                  <Videocam style={{ color: theme.palette.primary.dark, fontSize: 20 }} />
                </Box>): 
                "-"}
            </StyledTableCell>
        </TableRow>
        <TableRow>
            <StyledTableCell style={{ padding: 0 }} colSpan={8}>
              <Collapse 
                in={open}
                timeout="auto"
                unmountOnExit
                style={{
                  display: isFetching ? "flex" : "block",
                  justifyContent: "center",
                  flex: 1,
                  width: "100%",
                }}
              >
                {isFetching ? <>
                    <div style={{ padding: '20px'}}><CircularProgress /></div>
                  </> : (
                  <>
                    <Table>
                      <TableHead>
                          <TableRow style={{ padding: 10, background: '#f5f3f3'}}>
                              <StyledTableHeadCell style={{ position: 'relative', width: '120px', minWidth: '120px', background: '#f5f3f3' }}>
                                  <Box display='flex' flex={1} justifyContent='space-between' alignItems='center'>
                                      Date
                                  </Box>
                              </StyledTableHeadCell>
                              <StyledTableHeadCell style={{ position: 'relative', width: '70px', minWidth: '70px', background: '#f5f3f3' }}>
                                  <Box display='flex' flex={1} justifyContent='space-between' alignItems='center'>
                                      Linked
                                  </Box>
                              </StyledTableHeadCell>
                              <StyledTableHeadCell style={{ position: 'relative', minWidth: '90px', background: '#f5f3f3' }} >
                                  <Box display='flex' flex={1} justifyContent='space-between' alignItems='center'>
                                      Domain Rank
                                  </Box>
                              </StyledTableHeadCell>
                              <StyledTableHeadCell style={{ position: 'relative', background: '#f5f3f3', textAlign: 'center' }}>
                                  <Box display='flex' flex={1} justifyContent='center'>
                                      Media
                                  </Box>
                              </StyledTableHeadCell>
                              <StyledTableHeadCell style={{ position: 'relative', maxWidth: '500px', background: '#f5f3f3' }}>
                                  <Box display='flex' flex={1} justifyContent='space-between'>
                                      Link URL
                                  </Box>
                              </StyledTableHeadCell>
                          </TableRow>
                      </TableHead>
                      <TableBody>
                        {placements.map((placement) => (
                          <TableRow key={placement.link} style={{ padding: 10, overflow: "hidden", borderBottom: '1px solid #f5f3f3'}}>
                            <StyledTableCell component="th" scope="row" style={!Number.isNaN(new Date(placement.date).getTime())? { width: '120px', minWidth: '120px' }: { width: '120px', minWidth: '120px', textAlign: 'center' }} >
                              <Grid item xs={4} style={{ color:"grey", minWidth: '100px'}}> 
                                <span>
                                  {`${ !Number.isNaN(new Date(placement.date).getTime())? new Date(placement.date).toLocaleString('en-US', {
                                    year: 'numeric',
                                    month: 'short',
                                    day: 'numeric',
                                  }):
                                  "--"}`}
                                </span>
                              </Grid>
                            </StyledTableCell>
                            <StyledTableCell component="th" scope="row" style={{ width: '50px', minWidth: '50px'  }} >
                              <Grid style={{color:"grey"}} item xs={4}>
                                <span>{placement.linked.substring(0, placement.linked && String(placement.linked).indexOf("|"))}</span>
                              </Grid>
                            </StyledTableCell>
                            <StyledTableCell component="th" scope="row" style={{ width: '90px', minWidth: '90px'  }} >
                              <Grid style={{color:"grey"}} item xs={4}>
                                <span>{placement.dr}</span>
                              </Grid>
                            </StyledTableCell>
                            <StyledTableCell component="th" scope="row" style={{ width: '90px', minWidth: '90px', textAlign: 'center' }} >
                                {placement.video === true ? (
                                  <Box display='flex' flex={1} justifyContent='center' style={{width: "100%"}}>
                                    <Videocam style={{ color: theme.palette.primary.dark, fontSize: 20 }} />
                                  </Box>): 
                                  "-"}
                            </StyledTableCell>
                            <StyledTableCell component="th" scope="row" >
                              <Grid spacing={3}>
                                <div style={{ 
                                  display: "flex", 
                                  gap: '10px', 
                                  color: '#00B5E2',
                                  width: '100%',
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}>
                                  <LinkIcon style={{ width: "14px"}} />
                                  <a 
                                    href={placement.link} 
                                    style={{ 
                                      textDecoration: 'none',
                                    }} 
                                    target="_blank"
                                    rel="noreferrer">
                                    <div className={classes.prLink}>
                                      {placement.link}
                                    </div>
                                  </a>
                                </div>
                              </Grid>
                            </StyledTableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </>)}
              </Collapse>
            </StyledTableCell>
        </TableRow>
    </>
  );
};

SearchIntelligenceRow.propTypes = {
  row: PropTypes.shape({
    campaign_name: PropTypes.string,
    first_link_date: PropTypes.string,
    ht_count_links: PropTypes.number,
    count_links: PropTypes.number,
    created_date: PropTypes.string,
    month: PropTypes.string,
    year: PropTypes.string,
    status: PropTypes.string,
    video: PropTypes.bool,
  })
};

SearchIntelligenceRow.defaultProps = {
  row: {}
};

export default SearchIntelligenceRow;
